module.exports = __webpack_public_path__ + "static/media/contains-organic-material.efc13f8f.png";